import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=bd825436&scoped=true"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"
import style0 from "./pay.vue?vue&type=style&index=0&id=bd825436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd825436",
  null
  
)

export default component.exports